<script lang="ts">
  import type { HTMLAttributes } from "svelte/elements"

  import { type WithElementRef, cn } from "@/utils"

  let {
    ref = $bindable(null),
    class: className,
    children,
    ...restProps
  }: WithElementRef<HTMLAttributes<HTMLDivElement>> = $props()
</script>

<div
  bind:this={ref}
  data-slot="card-header"
  class={cn(
    "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
    className,
  )}
  {...restProps}
>
  {@render children?.()}
</div>
